export enum MENU_TAB {
  LATEST = 'LATEST',
  GROUP_CHATS = 'GROUP_CHATS',
  LIVE_CHATS = 'LIVE_CHATS',
  LATEST_DIRECT_CHATS = 'LATEST_DIRECT_CHATS',
  DIRECT_CHATS = 'DIRECT_CHATS',
  WELCOME_MESSAGES = 'WELCOME_MESSAGES',
  INTEGRATIONS = 'INTEGRATIONS',
  DASHBOARD = 'DASHBOARD',

  VIDEO_COLLECTIONS = 'VIDEO_COLLECTIONS'
}

export enum TOPIC_VIEW {
  CHAT_VIEW = 'CHAT_VIEW',
  VIDEO_VIEW = 'VIDEO_VIEW',
}

export enum WIDGET_VIEW {
  WELCOME = 'WELCOME',
  LANDING = 'LANDING',
  PAST_CONVERSATIONS = 'PAST_CONVERSATIONS',
  MESSENGER = 'MESSENGER',
  VIDEO_RECORDER = 'VIDEO_RECORDER',
  AUDIO_RECORDER = 'AUDIO_RECORDER',
  LANDING_MESSENGER = 'LANDING_MESSENGER',
  VIDEO_OPTIONS = 'VIDEO_OPTIONS',
  AUDIO_OPTIONS = 'AUDIO_OPTIONS',
  MULTI_CHOICE = 'MULTI_CHOICE',
  EMAIL_CAPTURE = 'EMAIL_CAPTURE',
  NAME_CAPTURE = 'NAME_CAPTURE',
  PRODUCTS = 'PRODUCTS',
  TEXT_INPUT = 'TEXT_INPUT',
  LINK = 'LINK'
}

type EmptyRecord = Record<string, never>

/*
An object containing all the data necessary to reproduce a specific state in the app.
Since the app location can be preloaded from the server, null is used instead of undefined. This is because there is no
representation of undefined on the server, and due to the fact that the preload state is injected directly into the
redux store without preprocessing. Currently memberId is the only required property. This may change in the future,
if there are locations outside the scope of a member.
*/
export type AppLocation = {
  memberId: number
  url: string | null
  menuTab: MENU_TAB | null
  topicView: TOPIC_VIEW | null
  topicId: number | null
  directChatHandle: string | null
  welcomeMessageId: string | null
  widgetQuestionId: string | null
  widgetView: WIDGET_VIEW | null
  productURL: string | null
}

/*
Allows a subset of properties from the AppLocation type.
It is combined with the previous state and defaults to construct a complete and valid AppLocation.
*/
export type AppLocationFragment = {
  memberId?: number | null
  url?: string | null
  menuTab?: MENU_TAB | null
  topicView?: TOPIC_VIEW | null
  topicId?: number | null
  directChatHandle?: string | null
  widgetView?: WIDGET_VIEW | null
  welcomeMessageId?: string | null
  videoCollectionId?: string | null
  widgetQuestionId?: string | null
  productURL?: string | null
}

export type AppLocationCache = { [memberId: number]: AppLocation }

export type AppLocationCacheWithMetadata = {
  lastSetMemberId: number | undefined
  cache: AppLocationCache
}

export type AppLocationContextType = {
  appLocation: AppLocation | EmptyRecord
  prevAppLocation: AppLocation | EmptyRecord
  setAppLocation: any
  appLocationCache: AppLocationCache
  goBack: any
  setAppLocationCache: any
  ready: boolean
}

export const emptyObject = {}

export const appLocationCacheInitialState = {
  lastSetMemberId: undefined,
  cache: emptyObject,
}
